export default "__VITE_ASSET__sstjQjaJ__"